import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=af5c512a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=af5c512a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c512a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5c512a')) {
      api.createRecord('af5c512a', component.options)
    } else {
      api.reload('af5c512a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=af5c512a&scoped=true&", function () {
      api.rerender('af5c512a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27yABboA4emuJ/JS/comp/Voucher.vue"
export default component.exports